/** @jsx jsx */
// import moment from 'moment';
import React, { useMemo, useState, useCallback } from 'react';
import { Column } from 'react-table';
import { Link } from 'react-router-dom';
import { css, jsx } from '@emotion/core';
import DataTable from 'components/organismos/DataTable/DataTable';
import HolidayMasterDomain from 'domain/master/labor/holidayMaster';
import { deleteById } from 'api/holidayMaster';
import { useOrgTreesOptionsAll } from 'hooks/useOrgTreesOptions';
// import ConfirmActionModal, { ActionType } from 'components/organismos/ConfirmActionModal';
import useToastNotification from 'hooks/useToastNotification';
import { useHolidayMasterList } from './hooks';
import SidebarTemplate from 'components/templates/SidebarTemplate';
// import CalendarForm from 'components/molecules/CalendarForm';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import { Row, Col } from 'react-grid-system';
import { grayScale, textFontSize } from 'components/styles';
import FormContents from 'components/atoms/Form/FormContents';
import FormPadding from 'components/atoms/Form/FormPadding';
import IconLabelButton from 'components/molecules/IconLabelButton';
import FlexBox from 'components/atoms/FlexBox';
import { DeleteButton, InfoButton, SubActionButton } from 'components/atoms/Button';
import BlockUI from 'components/molecules/BlockUi';
import YearPicker from 'components/molecules/YearPicker/YearPicker';
import ConfirmModal from 'components/organismos/ConfirmModal';
import FormHeader from 'components/templates/FormHeader';
import SelectForm from 'components/molecules/SelectForm';
import FormLabel from 'components/atoms/Form/FormLabel';
import { useHistory } from "react-router-dom";

const HolidayMasterPage: React.FC<{}> = () => {
  const history = useHistory();
  // const startOfYear = moment()
  //   .startOf('year')
  //   .format('YYYY-MM-DD');
  const [selectedYear, setSelectedYear] = useState(Number(sessionStorage.getItem('selectedYearHolidayMaster')));
  //const [selectedYear, setSelectedYear] = useState<Date>(new Date(startOfYear));
  const [orgCode, setorgCode] = useState(sessionStorage.getItem('selectedOrgCodeHolidayMaster'));
  
  const selectedStartDate = `${selectedYear}-01-01`;
  const selectedEndDate = `${selectedYear}-12-31`;
  // const selectedStartDate = `${moment(selectedYear).format('YYYY')}-01-01`;
  // const selectedEndDate = `${moment(selectedYear).format('YYYY')}-12-31`;
  const orgTreesOptions = useOrgTreesOptionsAll(selectedStartDate, selectedEndDate);
  
  const { holidayList, setHolidayList, isLoading } = useHolidayMasterList(String(orgCode), String(selectedYear));

  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [selectedHolidayMaster, setSelectedHolidayMaster] = useState(HolidayMasterDomain.generateInitial());

  const { successNotification, errorNotification } = useToastNotification();

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  const openConfirmModal = useCallback((holiday : HolidayMasterDomain) => {
    setConfirmModalOpen(true);
    setSelectedHolidayMaster(holiday);
  }, []);

  const deleteUpdateHoliday = useCallback(() => {
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
    deleteById(
      companyCode, selectedHolidayMaster.publicHolidayDate,
      selectedHolidayMaster.publicHolidayName,
      (String(orgCode))
    ).then((Response: any) => {
      setHolidayList(
        holidayList.filter(
          (holiday) => holiday.publicHolidayId !== selectedHolidayMaster.publicHolidayId
        )
      );
      // fix row is hidden alfter delete
      const old = orgCode;
      setorgCode('all');
      setorgCode(old);
      setConfirmModalOpen(false);
      successNotification('削除しました。');
    }).catch((error) => {
      setConfirmModalOpen(false);
      if (error.response && error.response.data && error.response.data.errors) {
        let msgError = '';
        error.response.data.errors.map((item: { defaultMessage: string; }) => {
          msgError += `${item.defaultMessage} \n`;
          return msgError;
        });
        errorNotification(msgError);
      } else {
        errorNotification('サーバー側でエラーが発生しました。');
      }
    });
  }, [errorNotification, 
      holidayList, 
      orgCode, 
      selectedHolidayMaster.publicHolidayDate,
      selectedHolidayMaster.publicHolidayId, 
      selectedHolidayMaster.publicHolidayName,
      setHolidayList, 
      successNotification]
  );

  const columns: Array<Column<HolidayMasterDomain>> = useMemo(() => [
    {
      Header: () => null,
      id: 'actionButton',
      disableSortBy: true,
      Cell: (cell: { 
        row :{ isExpanded: boolean, original: HolidayMasterDomain },
        data: Array<HolidayMasterDomain>
      }) => {
        return (
          <FlexBox>
            <FlexBoxItem width='36px' marginLeft="5px">
              <SubActionButton 
                action={0}
                text="編集"
                onClick={() => {
                  history.push(`/holiday/edit/${`${cell.row.original.publicHolidayId}/${cell.row.original.publicHolidayDate}/${cell.row.original.publicHolidayName}/${orgCode}/false`}`);
                }}
              />
            </FlexBoxItem>
            <FlexBoxItem margin="0 5px" width='36px'>
              <SubActionButton 
                action={1}
                onClick={() => {
                  openConfirmModal(cell.row.original);
                }}
                text="削除">
              </SubActionButton>
            </FlexBoxItem>  
          </FlexBox>
        );
      },
    },
    {
      Header: '日付',
      accessor: 'publicHolidayDateStr',
    },
    {
      Header: '祝日名',
      accessor: 'publicHolidayName',
    },
  ], [openConfirmModal, orgCode]);

  const style = {
    color: `${grayScale.gray60}`,
    fontSize: `${textFontSize.re}`
  };

  return (
    <SidebarTemplate pageTitle="労務規約項目マスタ">
      <BlockUI blocking={isLoading}>
        <FormHeader title="祝日マスタ" />
        <FormContents customStyle={css({marginTop:'60px', paddingTop: '8px'})}>
        <FormPadding>
            <Row>
              <Col md={1.2}>
                <FormLabel label="対象年" />
              </Col>
              <Col md={10.8}>
              <FlexBoxItem width='160px'>
                <YearPicker
                  selectedYear={selectedYear}
                  onChange={(year: any) => {
                    sessionStorage.setItem("selectedYearHolidayMaster", String(year));
                    setSelectedYear(year);
                  }}
                />
              </FlexBoxItem>
              </Col>
            </Row>
        </FormPadding>   
        <FormPadding>
            <Row>
              <Col md={1.2}>
                <FormLabel label="組織" />
              </Col>
              <Col md={10.8}>
              <FlexBoxItem width='450px'>
                <SelectForm
                  customStyle={css({ width: '450px' })}
                  label=""
                  name="orgCode"
                  value={String(orgCode)}
                  setValue={(v) => {
                    sessionStorage.setItem('selectedOrgCodeHolidayMaster', v);
                    setorgCode(v);
                  }}
                  options={orgTreesOptions}
                  required={false}
                />
                </FlexBoxItem>
              </Col>
            </Row>
          </FormPadding>
          <FormPadding>
            <Row>
              <FlexBoxItem customStyle={css({ display: 'flex' })}>
                <Link to="/holiday/import">
                  <IconLabelButton onClick={() => {}} iconType="addCircle" text="日本の祝日を取り込む" padding={'6px 0'} />
                </Link>
                <Link to="/holiday/create">
                  <IconLabelButton onClick={() => {}} iconType="addCircle" text="独自の祝日を作成" padding={'6px 20px'} />
                </Link>
              </FlexBoxItem>
            </Row>
          </FormPadding>
        <div>
          <div
            className='table-bordered table-padding'
            css={css`
              table th:nth-of-type(1) {
                width: 84px;
              }
              table td:nth-of-type(2) {
               text-align: center;
              }
              }
            `}
          >
            <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '15px' }}>
              <DataTable 
                className="table-no-border-left-right"
                classNameParrant="border-left-right"
                minWidth="100%" 
                columns={columns} 
                data={holidayList} 
                isGlobalFilter={true} 
                searchRight={false} 
              />
            </div>
          </div>
          <ConfirmModal
            open={confirmModalOpen}
            closeHandler={closeConfirmModal}
            onSubmit={deleteUpdateHoliday}
            title="祝日を削除"
            content="祝日を削除します。よろしいですか？"
            submitText="削除"
            typeSubmit={'reject'}
          />
          {/* <ConfirmActionModal
            open={confirmModalOpen}
            closeHandler={closeConfirmModal}
            onSubmit={deleteUpdateHoliday}
            actionType={ActionType.DELETE}
          /> */}
        </div>
      </FormContents>   
    </BlockUI> 
  </SidebarTemplate>
  );
};

export default HolidayMasterPage;
